import { Box, BoxProps, ColorOptions, Image, Spacer, Text } from '@jfs/ui-new'
import { FC } from 'react'
import { FlatList } from 'react-native'
import DottedImage, { dottedImageTypes } from '../../comps/ImageDotted'
import { openPlayStore } from '../../comps/ProductsMegaMenu'
import { SvgImage } from '../../comps/SvgImages'
import { accepyPaymentFlowData, featuresData, upiAppsData } from '../../static/staticData'
import { staticStrings } from '../../static/staticStrings'
import { colors } from '../../util/colors'
import useFontSize from '../../util/useFontSize'
import usePadding from '../../util/usePadding'
import { isMobileWidth, isTabletWidth, useWindowDimensions } from '../../util/util'

interface LayoutWithImageProps {
  data: any
  index?: number
  isLast?: boolean
}

const LayoutWithImage: FC<LayoutWithImageProps> = ({ data }: LayoutWithImageProps) => {
  const viewPortWidth = useWindowDimensions()

  const { textSize, textLineHeight } = useFontSize()
  const isMobile = isMobileWidth(viewPortWidth)
  const isTab = isTabletWidth(viewPortWidth)
  const resPadding = usePadding()
  const themedStyle = styles(viewPortWidth, resPadding)
  return (
    <Box {...themedStyle.container}>
      <Image source={data.image} width={isMobile ? 300 : 320} height={isMobile ? 300 : 320} resizeMode="center" />
      <Spacer size={isMobile ? 20 : isTab ? 24 : 28} direction={isTab ? 'horizontal' : 'vertical'} />
      <Text
        fontSize={textSize}
        lineHeight={textLineHeight}
        fontFamily="jiotype-medium"
        numberOfLines={2}
        textAlign={'center'}
        color={'#212112' as ColorOptions}>
        {data.text}
      </Text>
    </Box>
  )
}

const LayoutType1: FC<LayoutWithImageProps> = ({ data }: LayoutWithImageProps) => {
  const viewPortWidth = useWindowDimensions()
  const resPadding = usePadding()
  const themedStyle = styles(viewPortWidth, resPadding)

  const isMobile = isMobileWidth(viewPortWidth)
  const isTab = isTabletWidth(viewPortWidth)
  const arrowImg =
    isMobile || isTab
      ? require('../../assets/images/jiobizz/arrow-down.png')
      : require('../../assets/images/jiobizz/arrow.png')
  return (
    <Box bg={'WHITE'}>
      <Box {...themedStyle.layout1}>
        {data.map((item: any, index: any) => {
          return (
            <>
              <LayoutWithImage data={item} index={index + 1} isLast={index === data.length - 1} />
              {index !== data.length - 1 && (
                <Box {...themedStyle.containerArrow}>
                  <Image height={isMobile || isTab ? 48 : 16} width={isMobile || isTab ? 16 : 48} source={arrowImg} />
                </Box>
              )}
            </>
          )
        })}
      </Box>
      <AllUpiAppsLayout />
    </Box>
  )
}

const RenderItem = ({ item }: any) => {
  const { textSize, subHeaderSize, subHeaderLineHeight, textLineHeight } = useFontSize()
  const resPadding = usePadding()
  const width = useWindowDimensions()
  const isMobile = isMobileWidth(width)
  const isTab = isTabletWidth(width)
  const themedStyle = styles(width, resPadding)
  return (
    <Box {...themedStyle.featuresItemContainer}>
      <Image source={item.image} height={isMobile || isTab ? 48 : 80} width={isMobile || isTab ? 48 : 80} />
      <Spacer direction={isTab ? 'horizontal' : 'vertical'} size={isMobile ? 24 : isTab ? 32 : 40} />
      <Box {...themedStyle.featureTextContainer}>
        <Text
          title={item.title}
          fontSize={width > 2560 ? 32 : subHeaderSize}
          color={'BRAND_PRIMARY_BLACK'}
          fontFamily={'jiotype-bold'}
          lineHeight={width > 2560 ? 40 : subHeaderLineHeight}
        />
        <Box pt={isTab ? 8 : 16} width={'95%'}>
          <Text
            title={item.subTitle}
            fontSize={width > 2560 ? 24 : textSize}
            lineHeight={width > 2560 ? 32 : textLineHeight}
            color={'PRIMARY_GREY'}
            fontFamily={'jiotype-medium'}
          />
        </Box>
      </Box>
    </Box>
  )
}

const LayoutType2: FC = () => {
  const resPadding = usePadding()
  const width = useWindowDimensions()
  const isMobile = isMobileWidth(width)
  const isTab = isTabletWidth(width)
  const themedStyle = styles(width, resPadding)

  const keyExtractor = (item: any): string => {
    return item.id
  }

  const renderItem = ({ item }: any) => {
    return <RenderItem item={item} />
  }
  return (
    <Box>
      <FlatList
        data={featuresData}
        renderItem={renderItem}
        numColumns={isMobile || isTab ? 1 : 3}
        keyExtractor={keyExtractor}
        key={isMobile || isTab ? 1 : 3}
        style={themedStyle.listContainer}
      />
    </Box>
  )
}
const PaymentFlowLayout: FC = () => {
  const resPadding = usePadding()
  const width = useWindowDimensions()
  const isMobile = isMobileWidth(width)
  const isTab = isTabletWidth(width)
  const { textSize, textLineHeight } = useFontSize()
  const themedStyle = styles(width, resPadding)

  const renderItem = ({ item }: any) => {
    return (
      <Box {...themedStyle.paymentFlowItem}>
        <Image source={item.image} height={isMobile || isTab ? 32 : 40} width={isMobile || isTab ? 32 : 40} />
        <Spacer direction={'vertical'} size={isMobile || isTab ? 16 : 24} />
        <Text title={item.title} fontSize={textSize} color={'BRAND_PRIMARY_BLACK'} fontFamily={'jiotype-bold'} />
        <Box pt={8} w={'80%'}>
          <Text
            title={item.subTitle}
            lineHeight={textLineHeight}
            fontSize={textSize}
            color={'PRIMARY_GREY'}
            fontFamily={'jiotype-medium'}
          />
        </Box>
      </Box>
    )
  }

  const keyExtractor = (item: any): string => {
    return item.id
  }
  return (
    <FlatList
      data={accepyPaymentFlowData}
      renderItem={renderItem}
      numColumns={isMobile ? 1 : isTab ? 2 : 3}
      keyExtractor={keyExtractor}
      key={isMobile ? 1 : isTab ? 2 : 3}
    />
  )
}
const AllUpiAppsLayout: FC = () => {
  const resPadding = usePadding()
  const width = useWindowDimensions()
  const isMobile = isMobileWidth(width)
  const isTab = isTabletWidth(width)
  const themedStyle = styles(width, resPadding)
  const { headerSize, headerLineHeight } = useFontSize()
  return (
    <Box {...themedStyle.upiAppsTopContainer}>
      <DottedImage position={dottedImageTypes.topRight} size={isMobile || isTab ? 150 : 260} isDark={false} />
      <Box {...themedStyle.upiAppsContainer} overflowY={'hidden'}>
        <Box {...themedStyle.upiAppsImageContainer}>
          <Image
            source={require('../../assets/images/jiobizz/bizz-app.png')}
            height={isMobile ? 448 : isTab ? 540 : 760}
            width={isMobile ? 300 : isTab ? 360 : 660}
          />
        </Box>
        <Box {...themedStyle.textContainer}>
          <Spacer direction={'vertical'} size={isTab ? 80 : 0} />
          <Box w={'75%'}>
            <Text
              title={staticStrings.acceptPayments}
              color={'BRAND_PRIMARY_BLACK'}
              fontFamily={'jiotype-black'}
              fontSize={headerSize}
              lineHeight={headerLineHeight}
              textAlign={'left'}
            />
          </Box>
          <Spacer direction={'vertical'} size={isMobile || isTab ? 32 : 48} />
          <Box flexDirection={'row'}>
            {upiAppsData.map((item) => {
              return (
                <Box flexDirection={'row'}>
                  <Image source={item.image} height={isMobile || isTab ? 24 : 40} width={isMobile || isTab ? 24 : 40} />
                  <Spacer direction={'horizontal'} size={isMobile || isTab ? 16 : 24} />
                </Box>
              )
            })}
          </Box>
          <Spacer direction={'vertical'} size={isMobile || isTab ? 24 : 48} />
          <Box {...themedStyle.underline} />
          <Spacer direction={'vertical'} size={24} />
          <PaymentFlowLayout />
        </Box>
      </Box>
    </Box>
  )
}

const FooterComp: FC = () => {
  const resPadding = usePadding()
  const { headerSize } = useFontSize()
  const width = useWindowDimensions()
  const isTab = isTabletWidth(width)
  const isMobile = isMobileWidth(width)
  const themedStyle = styles(width, resPadding)
  return (
    <Box {...themedStyle.footerContainer}>
      <Spacer size={isTab ? 0 : 24} />
      <Box {...themedStyle.footerSubContainer}>
        <Box {...themedStyle.circleContainer}>
          <SvgImage imageName={'Circle'} height={isTab || isMobile ? 300 : 700} outerCircleDirection={'right'} />
        </Box>
        <Box width="90%">
          <Text
            title={staticStrings.downloadApp}
            fontFamily={'jiotype-black'}
            color={'WHITE'}
            fontSize={headerSize}
            textAlign={'center'}
            lineHeight={isMobile ? 36 : 66}
          />
        </Box>
        <Box onPress={openPlayStore} pt={isMobile ? 40 : isTab ? 48 : 72} underlayColor="TRANSPARENT">
          <Image
            source={require('../../assets/images/google-play.png')}
            width={isTab || isMobile ? 108 : 162}
            height={isTab || isMobile ? 32 : 48}
            resizeMode={'contain'}
          />
        </Box>
        <Spacer size={isMobile || isTab ? 16 : 72} />
        <Image
          source={require('../../assets/images/jiobizz/jiobizz-footer.png')}
          width={isTab || isMobile ? 296 : 740}
          height={isMobile ? 236 : isTab ? 276 : 570}
          resizeMode={'contain'}
        />
        <Spacer size={isMobile ? 72 : isTab ? 72 : 180} />
      </Box>
    </Box>
  )
}
const styles = (breakpoint: number, responsivePadding: number) => {
  const isMobile = isMobileWidth(breakpoint)
  const isTab = isTabletWidth(breakpoint)
  const getJioBizzImageRight = () => {
    if (isMobile) {
      return 24
    }
    if (isTab) {
      return -160
    }
    if (breakpoint <= 1540) {
      return -320
    }
    return -420 - ((breakpoint - 1540) / 90) * 12 + responsivePadding
  }
  const getTop = () => {
    if (breakpoint <= 370) {
      return 200
    }
    if (breakpoint <= 526) {
      return 132
    }
    if (breakpoint < 600) {
      return 102
    }
    if (breakpoint <= 1024) {
      return 120
    }
    if (breakpoint < 1714) {
      return 288
    }
    return 196
  }
  return {
    layout1: {
      flexDirection: 'row',
      justifyContent: 'center',
      paddingHorizontal: responsivePadding,
      paddingVertical: isTab || isMobile ? 16 : 40,
      flexWrap: isMobile || isTab ? 'wrap' : 'nowrap',
      bg: 'WHITE',
    } as BoxProps,
    containerArrow: {
      flex: 1,
      minWidth: isMobile || isTab ? '100%' : 52,
      maxWidth: isMobile || isTab ? '100%' : undefined,
      justifyContent: 'center',
      alignItems: isTab ? 'flex-start' : 'center',
      paddingLeft: isTab ? 150 : 0,
      h: isTab || isMobile ? 120 : 320,
    } as BoxProps,
    container: {
      flexDirection: isTab ? 'row' : 'column',
      maxWidth: isTab ? '100%' : 300,
      minWidth: isTab ? '100%' : undefined,
      alignItems: 'center',
      ph: 6,
    } as BoxProps,
    listContainer: { marginHorizontal: responsivePadding },
    featuresItemContainer: {
      flexDirection: isTab ? 'row' : 'column',
      align: 'flex-start',
      justify: 'flex-start',
      w: isMobile || isTab ? '100%' : '33.3%',
      pv: 20,
      pt: isMobile || isTab ? 40 : 50,
    } as BoxProps,
    featureTextContainer: {
      f: isTab ? 1 : undefined,
      w: isTab || isMobile ? undefined : '85%',
    } as BoxProps,
    textContainer: {
      alignSelf: isMobile ? 'flex-start' : 'center',
      flex: isMobile || isTab ? undefined : 1,
      width: isTab ? '70%' : undefined,
    } as BoxProps,
    paymentFlowItem: {
      flexDirection: 'column',
      justify: 'flex-start',
      align: 'flex-start',
      w: isMobile ? '100%' : isTab ? '50%' : '29%',
      pv: 20,
      pr: 16,
    } as BoxProps,
    upiAppsTopContainer: {
      pl: responsivePadding,
      pv: isMobile || isTab ? 40 : 120,
    } as BoxProps,
    upiAppsContainer: {
      flexDirection: isMobile ? 'column' : 'row-reverse',
      align: 'center',
      justify: 'space-between',
    } as BoxProps,
    upiAppsImageContainer: {
      marginRight: getJioBizzImageRight(),
      marginTop: isMobile ? 0 : isTab ? -140 : 102,
    } as BoxProps,
    underline: {
      w: isMobile || isTab ? 56 : 136,
      h: 2,
      bg: colors.JIO_PRIMARY_ALPHA as ColorOptions,
      borderRadius: 10,
      opacity: 0.2,
    } as BoxProps,
    footerContainer: {
      ph: responsivePadding,
      bg: colors.JIO_PRIMARY_ALPHA as ColorOptions,
      align: 'center',
    } as BoxProps,
    footerSubContainer: {
      maxWidth: isTab || isMobile ? undefined : '80%',
      align: 'center',
    } as BoxProps,
    circleContainer: {
      position: 'absolute',
      top: getTop(),
    } as BoxProps,
    footerBorder: {
      h: 1,
      w: '100%',
      bg: 'WHITE_SEPERATOR',
      borderRadius: 10,
    } as BoxProps,
    bottomContainer: {
      flexDirection: 'row',
      justify: isMobile ? 'center' : 'space-between',
      w: '100%',
      pv: isMobile || isTab ? 28 : 32,
      flexWrap: 'wrap',
    } as BoxProps,
    emailContainer: {
      flexDirection: 'row',
      pb: isMobile ? 16 : 0,
      align: 'center',
    } as BoxProps,
  }
}

export { FooterComp, LayoutType1, LayoutType2 }
